var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._l((_vm.$store.state.carts),function(item,index){return _c('location-item',{key:index,attrs:{"item":item,"index":index}})}),_c('location-list')],2)}
var staticRenderFns = []

export { render, staticRenderFns }